// @ts-nocheck
import { object, string } from 'yup'
import { t } from 'ttag'

import { EMAIL_FIELD, PASSWORD_FIELD } from './model'

export const getSchema = () =>
  object().shape({
    [EMAIL_FIELD]: string()
      .email()
      .required(t`This field cannot be empty.`),
    [PASSWORD_FIELD]: string().required(t`This field cannot be empty.`),
  })